import React from "react";
import Peru1 from "../images/peru1.png";
import Peru2 from "../images/peru2.png";
import Peru3 from "../images/peru3.png";
import Peru4 from "../images/peru4.png";
import MapaActividad from "../images/mapaactividad.png";
import FondoMuni from "../images/fondomuni.png";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Helmet } from "react-helmet";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoMuni + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 500,
    width: "100%",
    marginTop: 40,
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 6: Perú, un territorio muy diverso"
        meta={[
          {
            property: "og:title",
            content: "Lámina 6: Perú, un territorio muy diverso",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "El territorio que ocupa el Perú es muy variado. Presenta una gran diversidad de paisajes.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="6" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="PERÚ, UN TERRITORIO MUY DIVERSO" color="primary" />
        <p>
          El territorio que ocupa el Perú es muy variado. Presenta una gran
          diversidad de paisajes. Podemos encontrar mar, ríos, valles,
          desiertos, bosques, selvas, estepas y sabanas. Cada uno de estos
          paisajes presenta diferentes climas: unos cálidos y otros bastante
          fríos o helados. También hay distintos relieves: algunos con muchas
          montañas y otros llanos.
        </p>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} xs={12}>
            <Actividad color="primary" />
            <p>
              <strong>
                Observa las imágenes de diferentes lugares del Perú y responde:
              </strong>
            </p>
            <ul>
              <li>
                ¿Qué ves en cada una de ellas? Descríbelas de manera escrita o
                verbal.
              </li>
              <li>
                ¿Has visto paisajes como estos cerca de tu localidad? Marca con
                un aspa (X) cuáles.
              </li>
            </ul>
            <p style={{ color: "#0072bc" }}>
              <strong>
                La vegetación y las especies de animales que habitan en estos
                lugares también son diversas. Esta variedad de paisajes es el
                resultado de muchos elementos, entre ellos, la cordillera de los
                Andes.
              </strong>
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <Grid
              container
              className={classes.root}
              spacing={2}
              alignItems="center"
              justify="center"
            >
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <img src={Peru1} alt="Localidad" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <img src={Peru2} alt="Localidad" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <img src={Peru3} alt="Localidad" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <img src={Peru4} alt="Localidad" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} xs={12}>
            <p>
              La diversidad de nuestro territorio hace que tengamos una enorme
              variedad de climas y de recursos naturales. Entre ellos están los
              bosques, los glaciares, los ríos y lagos, la flora, la fauna, el
              petróleo, los minerales, el gas natural, etc.
            </p>
            <Actividad color="primary" />
            <p>
              <strong>
                Observa la imagen. El territorio del Perú está dividido en
                departamentos. Colorea el departamento en el que vives. Luego,
                dibuja algo característico del territorio de tu departamento.
              </strong>
            </p>
            <Button
              variant="outlined"
              href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadania-activa-lamina-mapa.pdf"
              download
              color="primary"
            >
              Descargar mapa
            </Button>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={MapaActividad} alt="Mapa" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-6.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 6: Perú, un territorio muy diverso'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Las personas que nos cuidan"
        anteriorEnlace="/lamina-1-5"
        siguiente="El campo y la ciudad"
        siguienteEnlace="/lamina-1-7"
      />
    </>
  );
};

export default Lamina2;
